import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";
import {
  noNetworkMsg,
  exErrMsg,
  // successMsg,
  errorMsg,
  clearMsg,
  // infoMsg,
} from "../Utils/apiToasts";


const trainersBaseController = "api/trainers";

//===============Api for Create New Trainer========================

export const createTrainers = async (body) => {
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(`${trainersBaseController}/create-trainer`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Added New Trainer', 'Success')

          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      errorMsg(ex.response.data.message, "")
    }
  }
}

//===============Api for Get All Trainers========================
export const getAllTrainers = async (params) => {
  console.log(params)
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const parsedBody = generalFunc.generateUrlParams(params)
      console.log('parsed body: ', parsedBody)

      const response = await api.get(`${trainersBaseController}/get-all-trainers?${parsedBody}`, );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

// ===============Api for Activate Trainer by id========================

export const activateTrainers = async (id) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.patch(`${trainersBaseController}/activate-trainer-by-id?id=${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Activated Trainer', 'Success')

          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }


    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

// ===============Api for Deactivate Trainer by id========================

export const deactivateTrainers = async (id) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.patch(`${trainersBaseController}/deactivate-trainer-by-id?id=${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Deactivated Trainer', 'Success')

          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }


    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

//===============Api for Get Trainer by id========================

// export const getTrainerById = async (id) => {
//   if (navigator.onLine === false) {
//     toastr.error('No Internet Connection', 'Please try again');
//   } else {
//     try {
//       const response = await api.get(`${trainersBaseController}/get-trainer-by-id?trainerId=${id}`);
//       if (typeof response !== "undefined") {
//         if (response.status === 200) {
//           // toastr.success('Fetched Trainer', 'Success')

//           return response.data.data;
//         }
//       } else {
//         toastr.error("An Error occured", "Please try again")
//       }


//     } catch (ex) {
//       toastr.error("An Error occured", "Please try again")
//     }
//   }
// } 
export const getTrainerById = async (id) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/get-trainer-by-id?skillCenterId=${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          //toastr.success('Fetched Trainer', 'Success')

          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }


    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}


//===============Api for approve Trainer ========================

export const postApprovalComment = async (commentData) => {
  console.log('comment data is ', commentData)
  if (navigator.onLine === false) {
    toastr.error("No Internet Connection", "Please try again");
  } else {
    try {

      const response = await api.post(
        `${trainersBaseController}/approve-trainer`,
        commentData
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // toastr.success(response.data.message, "Success");
          toastr.success("Success");
          return response.data.data;
        }
      } else {
        toastr.error("An Error Occurred", "Please try again");
      }
    } catch (ex) {
      toastr.error("An Error Occurred", "Please try again");
      throw ex;
    }
  }
};



//===============Api for Update Trainer========================

export const updateTrainer = async (body) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.put(`${trainersBaseController}/update-trainer`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Updated Trainer', 'Success')

          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }
    } catch (ex) {
      // console.log(ex.response.data.message, "The error")
      if (ex.response.status === 400) {
        toastr.error(ex.response.data.message, "")
        // console.log(ex.response.status, "404 error")
      }
      else {
        toastr.error("An Error occured", "Please try again")
        /* console.log(ex.response.data.message) */
      }
    }
  }
}

//===============Api for Get All Trainer Total Details========================

export const getAllTotalTrainersDetails = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/get-total-trainer-details`);
      /*  console.log(response) */
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // // toastr.success('Get All Trainers', 'Success')
          return response.data.data;
        }

        // console.log(response)
      } else {
        toastr.error("An Error occured", "Please try again")
      }

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

//===============Api for Export Trainers========================

export const exportTrainers = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    // toastr.info("Downloading...", "Pending");
    await api
      .get(`${trainersBaseController}/export-trainers`, { responseType: "blob" })
      .then((response) => {
        // toastr.info("Downloading...");
        if (typeof response !== "undefined") {
          if (response.status === 200 || response.status === 204) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `SAED Trainers ${generalFunc.getCurrentYear()}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            toastr.clean();
            toastr.success("Download Trainers SpreadSheet", "Success");
          } else {
            toastr.clean();
            toastr.error(
              "Download Trainers SpreadSheet",
              "Error in fetching API"
            );

          }
        }
      })
      .catch((ex) => {
        console.log(ex, "Error")
        toastr.clean();
        toastr.error("An Error occured", "Please try again");
      });
  }
};

//===============Api for Print Trainers ========================
export const printTrainers = async () => {
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    // toastr.info("Printing...", "Pending");
    await api
      .get(`${trainersBaseController}/print-trainers`, { responseType: "blob" })
      .then((response) => {
        // infoMsg("Printing...");
        if (typeof response !== "undefined") {
          if (response.status === 200 || response.status === 204) {
            const url = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
            var iframe = document.createElement("iframe")
            iframe.style.display = "none"
            iframe.src = url
            document.body.appendChild(iframe)
            iframe.contentWindow.focus()
            iframe.contentWindow.print()

            // var preview = window.open(url);
            // preview.print();
            clearMsg();
            // successMsg("Print Trainers SpreadSheet", "Success");
          } else {
            clearMsg();
            errorMsg("Print Trainers SpreadSheet", "Error in fetching API");
          }
        }
      })
      .catch((error) => {
        clearMsg();
        exErrMsg();
        throw error;
      });
  }
};

//===============Api for Get All Trainers without Pagination========================

export const getAllTrainerSelect = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/get-all-trainers-no-pagination`);
      /*  console.log(response) */
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Get All TrainerSelect', 'Success')
          return response.data.data;
        }

        // console.log(response)
      } else {
        toastr.error("An Error occured", "Please try again")
      }

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

//===============Api for Download Trainers Bulk Template========================

export const downloadTrainerBulkTemplateApi = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    // toastr.info("Downloading...", "Pending");
    await api
      .get(`${trainersBaseController}/download-trainers-template`, { responseType: "blob" })
      .then((response) => {
        // toastr.info("Downloading...");
        if (typeof response !== "undefined") {
          if (response.status === 200 || response.status === 204) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `SAED Trainers Bulk Template.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            toastr.clean();
            toastr.success("Download Trainers Template", "Success");
          } else {
            toastr.clean();
            toastr.error(
              "Download Trainers Template",
              "Error in fetching API"
            );

          }
        }
      })
      .catch((ex) => {
        console.log(ex, "Error")
        toastr.clean();
        toastr.error("An Error occured", "Please try again");
      });
  }
};

//===============Api for Create Bulk Trainers========================

export const createBulkTrainersApi = async (body) => {
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(`${trainersBaseController}/import-trainers`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Added Bulk Trainers', 'Success')

          return response.data.data;
        }
      } else {
        toastr.error("An error occured")
      }
    } catch (ex) {
      errorMsg(ex.response.data.message, "")
    }
  }
}


//===============Api to Get Training Center REport========================

/**
 * The function `getTrainingCenterReport` is an asynchronous function that makes an API request to
 * retrieve a training center report, and handles any errors that occur during the process.
 * @param body - The `body` parameter is an object that contains the data needed for the API request.
 * @returns the data from the API response.
 */
export const getTrainingCenterReport = async (body) => {
  if (body?.filterOptions?.State === 'all') {
    delete body?.filterOptions.State;
  }

  const parsedBody = generalFunc.generateUrlParams(body)

  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/get-trainingCenter-report${parsedBody}`);
      return response.data;

    } catch (error) {
      if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST') {
        toastr.error("Ooops, an error occurred", "and it's not your fault, please try again shortly!");
      } else {
        toastr.error("We encountered an error processing that request", "Please try again shortly")
      }
      throw error;
    }
  }
}
//===============Api to Get Training Center REport========================

export const exportTrainingCenterReport = async (body) => {
  const parsedBody = generalFunc.generateUrlParams(body)
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/export-trainers${parsedBody}`, { responseType: "blob" });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `SAED Training Centers ${generalFunc.getCurrentYear()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      return true

    } catch (error) {
      if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST') {
        toastr.error("Ooops, an error occurred", "and it's not your fault, please try again shortly!");
      } else {
        toastr.error("We encountered an error processing that request", "Please try again shortly")
      }
      throw error;
    }
  }
}


// Print trainers report data
export const getTrainersReportDataNoPagination = async (body) => {
  const parsedBody = generalFunc.generateUrlParams(body)
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/get-all-trainers-no-pagination${parsedBody}`);
      return response.data;

    } catch (error) {
      if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST') {
        toastr.error("Ooops, an error occurred", "and it's not your fault, please try again shortly!");
      } else {
        toastr.error("We encountered an error processing that request", "Please try again shortly")
      }
      throw error;
    }
  }

}

//===============Api for Update Training Center========================

export const updateTrainingCenterApi = async (body) => {
  try {
    if (navigator.onLine) {
      const response = await api.put(
        `${trainersBaseController}/update-trainer`,
        body
      );
      // toastr.success(`Updates successfully saved`);
      return response.data.data;
    }
  } catch (error) {
    toastr.error(
      `We encountered an error saving your details`,
      `Please try again shortly`
    );
    throw error;
  }
};

export const getTrainerByEmailApi = async (email) => {
  try {
    if (navigator.onLine) {
      const response = await api.get(
        `${trainersBaseController}/get-trainer-by-email/${email}`
      );
      return response.data.data;
    }
  } catch (error) {
    toastr.error(
      error.response.data.message,
      `Please try again with a registered email`
    );
    throw error;
  }
};

export const exportVirtuallyApprovedTrainersApi = async (body = {}) => {
  // this API is shared between the virtual and physical approval modules
  // only difference is in the filter values
  // refer to the respective components for the implementation

  const parsedBody = generalFunc.generateUrlParams(body)
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/export-virtually-approved-trainers${parsedBody}`, { responseType: "blob" });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `SAED Training Centers ${generalFunc.getMonthString()} ${generalFunc.getCurrentYear()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      return true

    } catch (error) {
      if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST') {
        toastr.error("Ooops, an error occurred", "and it's not your fault, please try again shortly!");
      } else {
        toastr.error("We encountered an error processing that request", "Please try again shortly")
      }
      throw error;
    }
  }
}

export const getTrainingCenterFileByIdApi = async (id) => {
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${trainersBaseController}/get-training-center-files-by-id/${id}`);
      return response.data;
    } catch (error) {
      if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST') {
        toastr.error("Ooops, an error occurred", "and it's not your fault, please try again shortly!");
      } else {
        toastr.error("We encountered an error processing that request", "Please try again shortly")
      }
      throw error;
    }
  }
}